<template>
  <div class="myEventDesc">
    <!--会议信息描述区域-->
    <el-image
      :src="'/forum-pub-api/v1/minio/getFile?file_url=' + eventDesc.image_url"
      fit="cover"
    >
      <div slot="error" class="image-slot">
        <div class="errText">{{ eventDesc.name }}</div>
        <img
          class="el-image__inner"
          style="object-fit: cover"
          src="../assets/errbg.jpg"
        />
      </div>
    </el-image>
    <div class="event_info">
      <div class="event_title">{{ eventDesc.name }}</div>
      <div class="event_meta">
        <div class="meta_row">
          {{ orgLabel }}：<span>{{ eventDesc.setting_json.orgnizer }}</span>
        </div>
        <time class="meta_row"
          >{{ sDate }}：<span>{{
            changetoLocaleString(eventDesc.start_time)
          }}</span></time
        >
        <time class="meta_row"
          >{{ eDate }}：<span>{{
            changetoLocaleString(eventDesc.end_time)
          }}</span></time
        >
        <div class="meta_row">
          举办城市：<span>{{ eventDesc.setting_json.city }}</span>
        </div>
        <div class="meta_row">
          会议地址：<span>{{ eventDesc.setting_json.address }}</span>
        </div>
        <div class="meta_row">
          {{ maxPeopleLabel }}：<span>{{
            eventDesc.setting_json.max_people
          }}</span>
        </div>
      </div>
      <!--
            <div class="event_meta">
                <div class="meta_row">{{ contactsLabel }}：<span>{{ eventDesc.contacts }}</span></div>
                <div class="meta_row">{{ telLabel }}：<span>{{ eventDesc.tel }}</span></div>
            </div>
            -->
      <div class="event_meta">
        <div class="meta_row">
          {{ signUpStateLabel }}：
          <span style="margin-right: 20px;color: rgb(255, 158, 64); font-weight:bold;">
            <span v-if="this.registration_status === 1">已报名</span>
            <span v-else>未报名</span>
          </span>
          {{ submitStateLabel }}：
          <span style="color: rgb(255, 158, 64); font-weight:bold;">
            <span v-if="this.thesisList.length !== 0">已投稿</span>
            <span v-else>未投稿</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEventDetail } from '@/apis/eventDetail.js';
import { getMyThesisList } from '@/apis/myThesisList';
import { getRegistration } from '@/apis/registration';

export default {
  name: 'MyEventDesc',
  props: {},
  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');

    let forum_id = Number(this.$route.query.eventId);
    getRegistration({ forum_id: forum_id })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);
            if (res.data.data.registration_status === 1) {
              this.$store.commit('AddCurrentRegistrationState', 1);
              // 如果获取到的报名状态为1，设定报名状态为1
            } else {
              this.$store.commit('AddCurrentRegistrationState', 0);
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('报名表未获取成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // 获取投稿列表
    getMyThesisList({
      forum_id: forum_id,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.$store.commit('AddMyThesisList', res.data.data.items);
          } else {
            this.$message.error(res.data.message);
          }
          console.log('ThesisList', res.data);
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // 获取会议详情
    getEventDetail(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);
            this.eventDesc = res.data.data.item;
            this.eventDesc.setting_json = res.data.data.item.setting_json;
            let eventTitle = this.eventDesc.name;
            this.$emit('eventTitle', eventTitle);
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      // 会议基本信息
      forumId: null,
      orgLabel: '主办单位',
      sDate: '开始时间',
      eDate: '结束时间',
      contactsLabel: '联系人',
      telLabel: '电话',
      locationLabel: '会议地点',
      maxPeopleLabel: '人数限制',
      eventDesc: {
        setting_json: {},
        contacts: '',
        tel: '',
      },
      signUpStateLabel: '报名状态',
      submitStateLabel: '投稿状态',
    };
  },
  methods: {
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
  },
  computed: {
    registration_status: {
      get() {
        return this.$store.state.toGetCurrentRegistration.registration_status;
      },
    },
    thesisList: {
      get() {
        return this.$store.state.toGetMyThesisList.thesisList;
      },
    },
  },
};
</script>

<style scoped></style>
